import Products from 'components/productsList';

const AddMembershipPage = () => {
  return <Products />;
};

export default AddMembershipPage;
